module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    class: _vm.getClassList(),
    attrs: {
      "href": _vm.href ? _vm.href : 'javascript:;'
    },
    on: {
      "click": _vm.action
    }
  }, [(_vm.iconName) ? [_c('icon', {
    attrs: {
      "name": _vm.iconName,
      "height": "16",
      "width": "16"
    }
  })] : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.text))])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d6d8f482","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppButton.vue
// module id = 1061
// module chunks = 1